import { render, staticRenderFns } from "./Pqrs.vue?vue&type=template&id=1242826e&scoped=true"
import script from "./Pqrs.vue?vue&type=script&lang=js"
export * from "./Pqrs.vue?vue&type=script&lang=js"
import style0 from "./Pqrs.vue?vue&type=style&index=0&id=1242826e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1242826e",
  null
  
)

export default component.exports